import { useState, useEffect } from "react";
import { api } from "../../context";

export default function Traffic({ t }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;

  useEffect(() => {
    api("/admin/dashboard").then(r => {
      if (r.ok) setData(r.data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: 40, color: SUB, textAlign: "center" }}>⏳ Loading traffic data...</div>;

  const fmt = (n) => Number(n || 0).toLocaleString();

  const sourceColors = {
    instagram: "#e91e8c", whatsapp: "#25d366", facebook: "#1877f2",
    google: "#ea4335", direct: SUB, twitter: "#1da1f2",
    tiktok: "#ff0050", telegram: "#0088cc", other: GOLD,
  };

  const sourceIcons = {
    instagram: "📸", whatsapp: "💬", facebook: "👥",
    google: "🔍", direct: "🔗", twitter: "🐦",
    tiktok: "🎵", telegram: "✈️", other: "🌐",
  };

  const trafficTotal = (data?.traffic_sources || []).reduce((a, s) => a + (s.count || 0), 0);
  const deviceTotal  = (data?.devices || []).reduce((a, d) => a + (d.count || 0), 0);
  const browserTotal = (data?.browsers || []).reduce((a, b) => a + (b.count || 0), 0);
  const pageTotal    = (data?.top_pages || []).reduce((a, p) => a + (p.count || 0), 0);

  return (
    <div>
      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>🚦 Traffic</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>Where users come from, what they visit, and how they behave</div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Logins Today", value: fmt(data?.today_logins?.length || 0), color: PRI },
          { label: "New Today", value: fmt(data?.new_today), color: GRN },
          { label: "Active Today", value: fmt(data?.active_today), color: GOLD },
          { label: "Traffic Sources", value: data?.traffic_sources?.length || 0, color: "#8b5cf6" },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "18px 20px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
        {/* Traffic Sources */}
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🚦 Traffic Sources (30 days)</div>
          {!data?.traffic_sources?.length
            ? <div style={{ textAlign: "center", padding: "30px 0", color: SUB, fontSize: 13 }}>No traffic data yet — will appear as users login</div>
            : data.traffic_sources.map((s, i) => {
              const pct = trafficTotal > 0 ? Math.round(s.count / trafficTotal * 100) : 0;
              const color = sourceColors[s.utm_source] || PRI;
              const icon  = sourceIcons[s.utm_source] || "🌐";
              return (
                <div key={i} style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 16 }}>{icon}</span>
                      <span style={{ fontSize: 13, fontWeight: 700, color: TEXT, textTransform: "capitalize" }}>{s.utm_source}</span>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <span style={{ fontSize: 13, fontWeight: 800, color }}>{pct}%</span>
                      <span style={{ fontSize: 11, color: SUB, marginLeft: 6 }}>({s.count})</span>
                    </div>
                  </div>
                  <div style={{ height: 8, borderRadius: 4, background: BORDER }}>
                    <div style={{ height: 8, borderRadius: 4, background: color, width: `${pct}%`, transition: "width 0.8s" }} />
                  </div>
                </div>
              );
            })
          }
        </div>

        {/* Most visited pages */}
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📄 Most Visited Pages (7 days)</div>
          {!data?.top_pages?.length
            ? <div style={{ textAlign: "center", padding: "30px 0", color: SUB, fontSize: 13 }}>No page view data yet — will appear as users navigate</div>
            : data.top_pages.map((p, i) => {
              const pct = pageTotal > 0 ? Math.round(p.count / pageTotal * 100) : 0;
              const pageIcons = { feed: "🏠", red_room: "🔴", events: "🎉", movies: "🎬", games: "🎮", messages: "💬", profile: "👤", leaderboard: "🏆", meetups: "💕", wallet: "💰", settings: "⚙️" };
              const icon = pageIcons[p.page] || "📄";
              return (
                <div key={i} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span>{icon}</span>
                      <span style={{ fontSize: 13, fontWeight: 600, color: TEXT, textTransform: "capitalize" }}>{p.page?.replace(/_/g, " ")}</span>
                    </div>
                    <div>
                      <span style={{ fontSize: 13, fontWeight: 800, color: PRI }}>{pct}%</span>
                      <span style={{ fontSize: 11, color: SUB, marginLeft: 6 }}>({p.count})</span>
                    </div>
                  </div>
                  <div style={{ height: 6, borderRadius: 3, background: BORDER }}>
                    <div style={{ height: 6, borderRadius: 3, background: PRI, width: `${pct}%`, transition: "width 0.8s" }} />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
        {/* Device breakdown */}
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📱 Device Types (30 days)</div>
          {!data?.devices?.length
            ? <div style={{ textAlign: "center", padding: "30px 0", color: SUB, fontSize: 13 }}>No device data yet</div>
            : (
              <>
                <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
                  {data.devices.map((d, i) => {
                    const pct = deviceTotal > 0 ? Math.round(d.count / deviceTotal * 100) : 0;
                    const icons = { mobile: "📱", desktop: "💻", tablet: "📟" };
                    const colors = { mobile: GRN, desktop: PRI, tablet: GOLD };
                    const color = colors[d.device_type] || SUB;
                    return (
                      <div key={i} style={{ flex: 1, background: t.input, borderRadius: 12, padding: 14, textAlign: "center", border: `1px solid ${BORDER}` }}>
                        <div style={{ fontSize: 24, marginBottom: 8 }}>{icons[d.device_type] || "💻"}</div>
                        <div style={{ fontSize: 22, fontWeight: 800, color }}>{pct}%</div>
                        <div style={{ fontSize: 11, color: SUB, marginTop: 4, textTransform: "capitalize" }}>{d.device_type}</div>
                        <div style={{ fontSize: 10, color: SUB }}>({d.count})</div>
                      </div>
                    );
                  })}
                </div>
              </>
            )
          }
        </div>

        {/* Browser breakdown */}
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🌐 Browsers (30 days)</div>
          {!data?.browsers?.length
            ? <div style={{ textAlign: "center", padding: "30px 0", color: SUB, fontSize: 13 }}>No browser data yet</div>
            : data.browsers.map((b, i) => {
              const pct = browserTotal > 0 ? Math.round(b.count / browserTotal * 100) : 0;
              const browserColors = { Chrome: "#4285f4", Firefox: "#ff7139", Safari: "#006cbc", Edge: "#0078d4", Opera: "#ff1b2d" };
              const color = browserColors[b.browser] || SUB;
              return (
                <div key={i} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: TEXT }}>{b.browser}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color }}>{pct}% ({b.count})</span>
                  </div>
                  <div style={{ height: 6, borderRadius: 3, background: BORDER }}>
                    <div style={{ height: 6, borderRadius: 3, background: color, width: `${pct}%` }} />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>

      {/* Signups by day */}
      {data?.signups_by_day?.length > 0 && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>📈 New Signups (30 days)</div>
            <div style={{ fontSize: 12, color: GRN, fontWeight: 700 }}>+{data.new_today} today</div>
          </div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 80 }}>
            {data.signups_by_day.map((d, i) => {
              const max = Math.max(...data.signups_by_day.map(x => x.count || 0), 1);
              const h = Math.max(2, (d.count / max) * 76);
              return <div key={i} style={{ flex: 1, height: h, background: PRI, borderRadius: "2px 2px 0 0", opacity: 0.8, minWidth: 3 }} title={`${d.date}: ${d.count} signups`} />;
            })}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
            <span style={{ fontSize: 10, color: SUB }}>{data.signups_by_day[0]?.date?.slice(5)}</span>
            <span style={{ fontSize: 10, color: SUB }}>{data.signups_by_day[data.signups_by_day.length - 1]?.date?.slice(5)}</span>
          </div>
        </div>
      )}

      {/* Today's logins table */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>🔐 Today's Logins ({data?.today_logins?.length || 0})</div>
          <div style={{ fontSize: 11, color: SUB }}>IP · Device · Source</div>
        </div>
        {!data?.today_logins?.length
          ? <div style={{ textAlign: "center", padding: "24px 0", color: SUB, fontSize: 13 }}>No logins today yet</div>
          : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${BORDER}` }}>
                    {["User", "IP Address", "Device", "Browser", "OS", "Source", "Time"].map(h => (
                      <th key={h} style={{ padding: "8px 12px", textAlign: "left", color: SUB, fontWeight: 700, fontSize: 10, textTransform: "uppercase", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.today_logins.map((l, i) => {
                    const srcColor = sourceColors[l.source] || SUB;
                    return (
                      <tr key={i} style={{ borderBottom: `1px solid ${BORDER}20` }}>
                        <td style={{ padding: "8px 12px", color: TEXT, fontWeight: 600 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span>{l.emoji}</span>
                            <span>{l.user}</span>
                            {l.plan !== "free" && (
                              <span style={{ padding: "1px 6px", borderRadius: 10, fontSize: 9, fontWeight: 700, background: l.plan === "elite" ? `${GOLD}20` : `${GRN}20`, color: l.plan === "elite" ? GOLD : GRN }}>{l.plan}</span>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: "8px 12px", color: SUB, fontFamily: "monospace", fontSize: 11 }}>{l.ip}</td>
                        <td style={{ padding: "8px 12px", color: SUB, textTransform: "capitalize" }}>{l.device}</td>
                        <td style={{ padding: "8px 12px", color: SUB }}>{l.browser}</td>
                        <td style={{ padding: "8px 12px", color: SUB }}>{l.os}</td>
                        <td style={{ padding: "8px 12px" }}>
                          <span style={{ padding: "2px 8px", borderRadius: 10, fontSize: 10, fontWeight: 700, background: `${srcColor}20`, color: srcColor, textTransform: "capitalize" }}>
                            {sourceIcons[l.source] || "🌐"} {l.source}
                          </span>
                        </td>
                        <td style={{ padding: "8px 12px", color: SUB }}>{l.time}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
        }
      </div>
    </div>
  );
}